import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({ scrollOffset: 1000 });